import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './MessageSelectDisclaimer.module.scss';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';

function MessageSelectDisclaimer() {
  const { t } = useTranslation('resonance');

  return (
    <div className={scss.wrapper}>
      <div className={scss.titleWrapper}>
        <Icon icon={ICONS.Unclust} className={scss.icon} disableCommonStyles currentColor />
        <h3>{t('highPerformanceStatistics')}</h3>
      </div>
      <span className={scss.subtitle}>{t('selectMessageToSeeMoreInformation')}...</span>
    </div>
  );
}

export default MessageSelectDisclaimer;
